import React, { Component } from "react";
import Newlogo from "./pbhlogo.png";
import "./media.css";
import logo from "../newProviderApp/image/playbacklogo.png";
class Header extends Component {
   render() {
      const { isPro = false } = this.props;
      return (
         <>
            <nav id="navbar" className={`p-2 navbar ${!isPro && "py-3"}`}>
               <div className="  nav-logo-div h-100 py-2 px-2 ">
                  <img
                     className="h-100 pointer"
                     src={isPro ? logo : Newlogo}
                     height={42}
                     width={169}
                     alt={"playback-logo"}
                  />
               </div>
            </nav>
         </>
      );
   }
}

export default Header;
